<template>
  <div class=" overflow-hidden">
    <div class="ps-px-6 ps-py-6">
      <div class="sm:flex sm:items-center ps-opacity-50 ">
        <div
          class="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-gray-100 sm:mx-0 sm:h-10 sm:w-10"
        >
          <svg-icon
            name="card-comments"
            class="ps-w-6 ps-h-6 ps-svg-stroke-two ps-text-gray-600"
          />
        </div>
        <div class=" text-center sm:mt-0 sm:ml-4 sm:text-left">
          <h3
            class="text-lg leading-6 font-medium text-gray-900"
            id="modal-headline"
          >
            {{ label }}
          </h3>
          <!-- <div class="mt-2">
            <p class="text-sm leading-5 text-gray-500">
              {{ intro }}
            </p>
          </div> -->
        </div>
      </div>
    </div>
    <div>
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'SectionMeta',
  props: {
    label: String,
    intro: String
  }
}
</script>
